var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex flex-column flex-wrap align-center text-center"},[_c('h2',{staticClass:"text-h5"},[_vm._v(" "+_vm._s(_vm.$t('register'))+" ")]),_c('p',{staticClass:"text-h6 text--secondary"},[_vm._v(" "+_vm._s(_vm.$t('noCardRequired'))+" ")]),_c('div',{attrs:{"id":"firebaseui-auth-container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }